import React from 'react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

import Base from '../Select'

export const GET_TEMPLATES = gql`
  {
    templates {
      id
      key
    }
  }
`

const Select = ({...others}) => {
  return (
    <Query query={GET_TEMPLATES} fetchPolicy='cache-and-network'>
      {({data}) =>
        <Base
          options={!data || !data.templates
            ? []
            : data.templates.map(t => ({key: t.id, label: t.key, value: t.id}))}
          {...others}
        />
      }
    </Query>
  )
}

export default Select


// WEBPACK FOOTER //
// ./src/components/Templates/Select.js